import styled from 'styled-components';

export const Button = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-transform: ${({ theme }) => theme.btnTextTransform};

  &.primary {
    color: ${({ theme }) => theme.white};
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.primaryColor};
    background-color: ${({ theme }) => theme.primaryColor};
    text-transform: ${({ theme }) => theme.btnTextTransform};
    width: 100%;
    height: 45px;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;

    &:hover {
      color: ${({ theme }) => theme.white};
    }
  }

  &.text1 {
    color: ${({ theme }) => theme.primaryColor};
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
    text-transform: none;
  }

  &.text2 {
    color: ${({ theme }) => theme.primaryColor};
    text-transform: ${({ theme }) => theme.TitleTransform};
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
  }

  &.anchor {
    display: flex;
    align-items: center;
    color: #717171;
    text-decoration: underline;
    text-transform: ${({ theme }) => theme.titleTransform};

    &:hover {
      color: ${({ theme }) => theme.primaryColor};
    }
  }
`;
